import React, { useEffect, useState } from 'react';
import './SFCCatelog.less';

export interface IHeadItem {
  type: string;
  txt: string;
}

type Props = ISFCCatelogProps;
export interface ISFCCatelogProps {
  val?: string;
  itemClick?: (index: number) => void;
}

export function SFCCatelog(props: Props) {
  const { val = '', itemClick } = props;
  const [headList, setHeadList] = useState<IHeadItem[]>([]);

  useEffect(() => {
    const ele = document.createElement('div');

    ele.innerHTML = val;

    setHeadList(
      Array.from(ele.querySelectorAll('h1,h2,h3')).map(item => {
        return {
          type: item.tagName,
          txt: item.textContent || ''
        };
      })
    );
  }, [val]);

  const scrollTop = () => {
    document.body.scrollIntoView();
  };

  const scrollToTargetPart = (index: number) => {
    itemClick && itemClick(index);
  };

  return (
    <>
      {headList.length > 0 && (
        <section className="ql-catalog">
          <div className="ql-catalog__title" onClick={scrollTop}>
            <h3 className="ql-catalog__title__txt">目录</h3>
          </div>
          <ul className="ql-catalog__body">
            {headList.map((item, index) => {
              return (
                <li
                  key={index}
                  className={`ql-catalog__body__item`}
                  onClick={() => {
                    scrollToTargetPart(index);
                  }}
                >
                  <h4
                    className={`ql-catalog__body__txt ql-catalog__body__${item.type.toLowerCase()}`}
                  >
                    {item.txt}
                  </h4>
                </li>
              );
            })}
          </ul>
        </section>
      )}
    </>
  );
}

export default SFCCatelog;
